Addresses = window.Addresses = (function () {
    const selectors = {
        searchInput: '#search-input',
        bodyTableRowWrapper: '.addresses-body__table .addresses-body__table-row-wrapper',
        tableRowWrapper: '.addresses-body__table-row-wrapper',
        cityName: '.addresses-body__address-city',
        cityAddressName: '.addresses-body__address-name',
        tableRow: '.addresses-body__table-row',
        bodyTableSeparator: '.addresses-body__table .addresses-body__table-separator',
        tableSeparatorGroup: '.addresses-body__table-separator-group',
        expandedRow: '.addresses-body__expanded-row',
        expandedRowWrapper: '.addresses-body__expanded-row-wrapper',
        expandedRowTime: '.addresses-body__expanded-row-cell.m-time',
        scrollArea: '#m-page-content-scrollbar-scrollarea',
        emptySelector: '#empty_addresses'
    };

    const toggleMessage = 'endToggle';

    function init() {
        bindUI();
        Search.init('addresses');
    }

    function filterAddresses(query, pushCallback, withCity) {
        var cities = $(selectors.bodyTableRowWrapper);
        for (var k = 0; k < cities.length; k++) {
            var city = $(cities[k]);
            var cityName = city.find(selectors.cityName).text();
            var adrs = city.find(selectors.cityAddressName).filter(function(i, e) {
                if (withCity && cityName.toLowerCase().includes(query.toLowerCase())) return true;
                var splits = query.split(' ');
                return splits.filter(function(k) {
                    return $(e).text().toLowerCase().includes(k.toLowerCase());
                }).length == splits.length;
            });

            pushCallback(adrs, cityName);
        }
    }

    function filter(query) {
        var deferred = $.Deferred();

        var els = [];
        filterAddresses(query,
            function(adrs, cityName) {
                for (var j = 0; j < adrs.length; j++) {
                    els.push({
                        city: cityName,
                        address: $(adrs[j]).text()
                    });
                }
            }, true);
        window.Search.hide();

        var deffereds = [];
        var cities = $(selectors.bodyTableRowWrapper);
        for (var j = 0; j < cities.length; j++) {
            var city = $(cities[j]);
            var cityName = city.find(selectors.cityName).text();

            if (els.filter(function(el) { return el.city === cityName; }).length === 0) {
                city.hide();
                city.addClass("m-hidden");
            } else {
                var def = $.Deferred();
                deffereds.push(def);

                city.show();
                city.removeClass("m-hidden");

                var row = city.find(selectors.tableRow);
                row.one(toggleMessage,
                    function() {
                        //по адресам------
                        var addrs = $(this).closest(selectors.bodyTableRowWrapper).find(selectors.cityAddressName);
                        for (var i = 0; i < addrs.length; i++) {
                            var addr = $(addrs[i]);
                            var addrName = $(addr).text();
                            var exp = $(addr).closest(selectors.expandedRowWrapper);
                            if (els.filter(function(el) { return el.address === addrName; }).length === 0) {
                                exp.hide();
                                exp.addClass("m-hidden");
                            } else {
                                exp.show();
                                exp.removeClass("m-hidden");
                            }
                        }
                        def.resolve();
                    });
                if (row.hasClass("m-opened")) {
                    row.trigger(toggleMessage);
                } else {
                    row.click();
                }
            }
        }

        var separators = $(selectors.bodyTableSeparator);
        for (var l = 0; l < separators.length; l++) {
            var separator = $(separators[l]);
            var group = separator.siblings(selectors.tableSeparatorGroup + "[data-group=" + separator.text() + "]");
            if (group.length == 0) continue;

            if (group.find(selectors.tableRowWrapper + ':not(.m-hidden)').length == 0) {
                separator.addClass("m-hidden");
                separator.hide();
            } else {
                separator.show();
                separator.removeClass("m-hidden");
            }
        }

        if (deffereds.length > 0) {
            $.when(deffereds).done(function() { deferred.resolve(); });
        } else {
            deferred.resolve();
        }

        var empty = $(selectors.emptySelector);
        if (els.length === 0) {
            if (!empty.hasClass('active'))
                empty.addClass('active');
        } else {
            if (empty.hasClass('active'))
                empty.removeClass('active');
        }

        return deferred.promise();
    }

    function bindUI() {
        var lastQuery = '';
        app.body.on('keypress', selectors.searchInput,
            function(e) {
                if (e.which == 13) {
                    var query = $(this).val().trim();
                    if (query.trim() === lastQuery)
                        return false;
                    lastQuery = query.trim();

                    filter(query);

                    return false;
                }
            });
    }

    function dispose() {
        $('#page-content').empty();
    }

    function reset() {
        var cities = $(selectors.bodyTableRowWrapper);
        var citiesAdresses = $(selectors.expandedRowWrapper);

        if (citiesAdresses.hasClass("m-hidden")) citiesAdresses.removeClass("m-hidden").show();

        for (var j = 0; j < cities.length; j++) {
            var city = $(cities[j]);
            city.show();
            city.removeClass("m-hidden");
            var row = city.closest(selectors.tableRowWrapper).find(selectors.tableRow);
            if(row.hasClass("m-opened")) row.click();
        }

        var separators = $(selectors.bodyTableSeparator);
        for (var l = 0; l < separators.length; l++) {
            var separator = $(separators[l]);
            separator.show();
            separator.removeClass("m-hidden");
        }
    }

    return {
        selectors: selectors,
        init: init,
        dispose: dispose,
        search: function(query) {
            var els = [];
            filterAddresses(query,
                function(adrs, cityName) {
                    for (var j = 0; j < adrs.length; j++) {
                        els.push({
                            city: cityName,
                            address: $(adrs[j]).text(),
                            id: $(adrs[j]).closest(selectors.expandedRow).data('id'),
                            time: $(adrs[j]).parent().siblings(selectors.expandedRowTime).text()
                        });
                    }
                }, true);

            Search.drawResultEvents({
                events: els,
                overflow: els.length > 10
            }, query);
            Search.show();
        },
        select: function(id) {
            filter($(selectors.searchInput).val()).done(function() {
                var row = $(selectors.expandedRow + '[data-id=' + id + ']');
                var city = row.closest(selectors.tableRowWrapper).find(selectors.tableRow);

                var rowClick = function() {
                    row.one(toggleMessage,
                        function() {
                            var pageContentMargin = 20;
                            $(selectors.scrollArea).scrollTop(row.position().top - pageContentMargin);
                        });
                    if (row.closest(selectors.expandedRowWrapper).hasClass('m-opened')) {
                        row.trigger(toggleMessage);
                    } else {
                        row.click();
                    }
                };

                city.one(toggleMessage,
                    function() {
                        rowClick();
                    });
                if (city.hasClass('m-opened')) {
                    city.trigger(toggleMessage);
                } else {
                    city.click();
                }
            });
        },
        reset: reset
    }
}());

$(function() {
    Addresses.init();
});